import { breakpoints } from 'styles';
import { Filters, FiltersActive } from 'components/common/filter';
import { UsersSearch, UsersViewSelector } from '.';

const UsersFilters = () => {
  return (
    <div className="filters">
      <div className="main">
        <div className="search">
          <UsersSearch size="header" />
        </div>

        <div className="filter">
          <Filters
            allowMultiple={{
              accountAccess: true,
              accountIdentifier: true,
              accountLogin: true,
              accountType: true,
              achievements: true,
              ambitions: true,
              calendarEvents: true,
              competenceProfiles: true,
              competences: true,
              courses: true,
              groups: true,
              paths: true,
              supervisors: true,
              userAttributes: true
            }}
            filterId="users"
            filters={{
              accountAccess: true,
              accountIdentifier: true,
              accountLogin: true,
              accountType: true,
              achievements: true,
              ambitions: true,
              calendarEvents: true,
              competenceProfiles: true,
              competences: true,
              courses: true,
              groups: true,
              myTeam: true,
              paths: true,
              supervisors: true,
              userAttributes: true
            }}
          />
        </div>
        <div className="view">
          <UsersViewSelector />
        </div>
      </div>

      <FiltersActive filterId="users" />

      <style jsx>{`
        .filters {
          width: 100%;
        }
        .main {
          align-items: flex-start;
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          justify-content: space-between;
        }
        .search {
          max-width: 100%;
          width: 100%;
        }
        .view {
          flex-grow: 1;
          text-align: right;
        }
        @media (min-width: ${breakpoints.small}px) {
          .main {
            justify-content: normal;
          }
          .search {
            width: 240px;
          }
        }
      `}</style>
    </div>
  );
};

export default UsersFilters;
